/* eslint-disable max-lines */
export const config = {
    name: 'customerManage',
    searchFields: [
        {
            name: '客户名称',
            value: 'customerName',
            isFixed: true,
            type: 'input',
            span: 4
        },
        {
            name: '客户编码',
            value: 'customerCode',
            isFixed: true,
            type: 'input',
            span: 4
        },
        {
            name: '集团编码',
            value: 'originalGroupCode',
            isFixed: true,
            type: 'input',
            span: 4
        },
        {
            name: '供应商编码',
            value: 'supplierCode',
            isFixed: true,
            type: 'input',
            span: 4
        },
        {
            name: '客户系',
            value: 'customerGroupName',
            isFixed: true,
            type: 'input',
            span: 4
        },
        {
            name: '内外渠',
            value: 'customerChannel',
            type: 'select',
            optionNum: 'LMDM_CUSTOMER_CHANNEL',
            isFixed: true,
            span: 4
        },
        {
            name: '客户状态',
            value: 'customerStatus',
            type: 'select',
            optionNum: 'SYS_WM_CUSTOMER_STATUS',
            isFixed: true,
            span: 4
        },
        {
            name: '创建用户',
            value: 'createUserName',
            type: 'advance',
            advanceConfig: [
                { 'prop': 'esusUserNameCn', 'value': '姓名' },
                { 'prop': 'esusLoginName', 'value': '美信号' }
            ],
            tableConfig: [
                { 'prop': 'esusLoginName', 'value': '美信号' },
                { 'prop': 'esusUserNameCn', 'value': '姓名' },
                { 'prop': 'escoCompanyNameCn', 'value': '部门' }
            ],
            prefix: '/api-lcrm',
            advanceUrl: '/crmUser/page',
            cbParams: ['esusUserNameCn#createUserName', 'esusLoginName#createUserCode'],
            beforeRequest: (params) => {
                const inputKey = (params.esusUserNameCn ? params.esusUserNameCn : (params.esusLoginName ? params.esusLoginName : '')).trim();
                const reg = new RegExp('[\\u4E00-\\u9FFF]+', 'g'); // 中文字符正则
                if (reg.test(inputKey)) {
                    params.esusUserNameCn = inputKey;
                    params.esusLoginName = null;
                } else {
                    params.esusLoginName = inputKey;
                    params.esusUserNameCn = null;
                }
                return params;
            },
            isFixed: true,
            span: 4
        },
        {
            name: '社会信用代码',
            value: 'societyCreditCode',
            type: 'input',
            isFixed: true,
            span: 4
        },
        {
            name: '是否成功同步集团',
            value: 'pushStatusNonDynamic',
            type: 'select',
            optionNum: 'CUSTOMER_PUSH_STATUS',
            isFixed: true,
            span: 4
        },
        {
            name: '客户大类编码',
            value: 'customerCategoryCode',
            isFixed: false,
            type: 'input',
            span: 4
        },
        {
            name: '客户大类',
            value: 'customerCategory',
            isFixed: false,
            type: 'input',
            span: 4
        }
    ],
    selection: true,
    index: false,
    columns: [
        {
            label: '客户编码',
            prop: 'customerCode',
            fixed: 'left',
            filterModel: '',
            filterType: 'input',
            width: 140
        },
        {
            label: '客户名称',
            prop: 'customerName',
            filterModel: '',
            filterType: 'input',
            width: 200,
            fixed: 'left'
        },
        {
            label: '客户控制类型',
            prop: 'customerBodyType',
            filterModel: '',
            filterType: 'select',
            type: 'select',
            optionsKey: 'SYS_RELATION_LEVEL',
            width: 130
        },
        {
            label: '客户简称',
            prop: 'customerShortName',
            filterModel: '',
            filterType: 'input',
            width: 120
        },
        {
            label: '关联主客户编码',
            prop: 'belongCustomerCode',
            filterModel: '',
            filterType: 'input',
            width: 130
        },
        {
            label: '客户状态',
            prop: 'customerStatus',
            filterModel: '',
            filterType: 'select',
            type: 'select',
            optionsKey: 'SYS_WM_CUSTOMER_STATUS',
            width: 100
        },
        {
            label: '内外渠',
            prop: 'customerChannel',
            filterModel: '',
            filterType: 'select',
            type: 'select',
            optionsKey: 'LMDM_CUSTOMER_CHANNEL',
            width: 140
        },
        {
            label: '是否白名单',
            prop: 'isWhitelist',
            filterModel: '',
            filterType: 'select',
            type: 'select',
            optionsKey: 'SYS_YES_NO',
            width: 100
        },
        {
            label: '美的渠道角色',
            prop: 'customerChannelRole',
            filterModel: '',
            filterType: 'select',
            type: 'select',
            optionsKey: 'LMDM_CUSTOMER_CHANNEL_ROLE',
            width: 150
        },
        {
            label: '客户系',
            prop: 'customerGroupName',
            filterModel: '',
            filterType: 'input',
            width: 140
        },
        {
            label: '企业集团',
            prop: 'groupRename',
            width: 120
        },
        {
            label: '企业集团取值来源',
            prop: 'groupRenameSource',
            value: 'groupRenameSource',
            optionsKey: 'GROUP_RENAME_SOURCE',
            type: 'select',
            width: 120
        },
        {
            label: '行业大类',
            prop: 'industryCategoriesName',
            // filterModel: '',
            // filterType: 'select',
            // type: 'select',
            // optionsKey: 'SYS_INDUSTRY_TYPE',
            width: 140
            // slot:''
        },
        {
            label: '细分行业',
            prop: 'industryType',
            // filterModel: '',
            // filterType: 'select',
            type: 'select',
            optionsKey: 'SYS_INDUSTRY_TYPE',
            width: 120
        },
        {
            label: '客户等级',
            prop: 'customerLevelCode',
            type: 'select',
            optionsKey: 'NEOCRM_CUSTOMER_LEVEL', // 后端确认与细分等级用同一个 wy-yy
            width: 100
        },
        {
            label: '细分等级',
            prop: 'calCustomerLevelCode',
            filterModel: '',
            filterType: 'select',
            type: 'select',
            optionsKey: 'NEOCRM_CUSTOMER_LEVEL',
            width: 100
        },
        {
            label: '客户大类编码',
            prop: 'customerCategoryCode',
            width: 140
        },
        {
            label: '客户大类',
            prop: 'customerCategory',
            width: 140
        },
        {
            label: '客户集团编码',
            prop: 'originalGroupCode',
            filterModel: '',
            filterType: 'input',
            width: 140
        },
        {
            label: '所属事业部',
            prop: 'ebcuBuCode',
            filterModel: '',
            filterType: 'select',
            type: 'select',
            optionsKey: 'SYS_BUSINESS_UNIT',
            width: 140
        },
        {
            label: '客户经理/开发人',
            prop: 'customerOwnerName',
            // filterModel: '',
            // filterType: 'input',
            width: 150
        },
        {
            label: '风险等级',
            prop: 'riskLevel',
            filterModel: '',
            filterType: 'select',
            type: 'select',
            optionsKey: 'LMDM_RISKLEVEL',
            width: 100
        },
        {
            label: '客户分类',
            prop: 'ebcuCustomerType',
            filterModel: '',
            filterType: 'select',
            type: 'select',
            optionsKey: 'EBCU_CUSTOMER_TYPE',
            width: 100
        },
        {
            label: '双算标识',
            prop: 'bizRevId',
            // filterModel: '',
            // filterType: 'select',
            type: 'select',
            optionsKey: 'BIZ_REV_ID_TYPE',
            width: 100
        },
        {
            label: '社会信用代码',
            prop: 'societyCreditCode',
            filterModel: '',
            filterType: 'input',
            width: 150
        },
        {
            label: '营业执照号',
            prop: 'ebcuBusinessNo',
            filterModel: '',
            filterType: 'input',
            width: 150
        },
        {
            label: '组织机构代码',
            prop: 'ebcuOrgBarcode',
            filterModel: '',
            filterType: 'input',
            width: 150
        },
        {
            label: '纳税号',
            prop: 'ebcuTaxRegistNo',
            filterModel: '',
            filterType: 'input',
            width: 160
        },
        {
            label: '法人代表',
            prop: 'ebcuLegalEntity',
            filterModel: '',
            filterType: 'input',
            width: 140
        },
        {
            label: '客户形态',
            prop: 'customerProperty',
            filterModel: '',
            filterType: 'select',
            type: 'select',
            optionsKey: 'CUSTOMER_PROPERTY',
            width: 100
        },
        {
            label: '是否虚拟客户',
            prop: 'isVirtualCustomer',
            filterModel: '',
            filterType: 'select',
            type: 'select',
            optionsKey: 'SYS_CRM_YES_NO',
            width: 180
        },
        {
            label: '英文名称',
            prop: 'ebcuNameEn',
            filterModel: '',
            filterType: 'input',
            width: 140
        },
        {
            label: '战略合作类型',
            prop: 'teamType',
            filterModel: '',
            filterType: 'select',
            type: 'select',
            optionsKey: 'CUSTOMER_TEAM_TYPE',
            width: 140
        },
        {
            label: '供应商编码',
            prop: 'supplierCode',
            filterModel: '',
            filterType: 'input',
            width: 180
        },
        {
            label: '内外销客户',
            prop: 'isImpExpCustomer',
            filterModel: '',
            filterType: 'select',
            type: 'select',
            optionsKey: 'IS_IMP_EXP_CUSTOMER',
            width: 100
        },
        {
            label: '身份证',
            prop: 'idNumber',
            type: 'slot',
            filterModel: '',
            filterType: 'input',
            width: 180
        },
        {
            label: '中信保编码',
            prop: 'sinosureCode',
            filterModel: '',
            filterType: 'input',
            width: 140
        },
        {
            label: '成立日期',
            prop: 'ebcuRegistrationDate',
            // filterModel: '',
            // filterType: 'dateRange',
            width: 160
        },
        {
            label: '经营状态',
            prop: 'regStatus',
            // filterModel: '',
            // filterType: 'select',
            width: 100
        },
        {
            label: '人员规模',
            prop: 'staffNumRange',
            // filterModel: '',
            // filterType: 'numberRange',
            width: 100
        },
        {
            label: '参保人数',
            prop: 'socialStaffNum',
            // filterModel: '',
            // filterType: 'numberRange',
            width: 100
        },
        {
            label: '实收注册资本',
            prop: 'actualCapital',
            // filterModel: '',
            // filterType: 'numberRange',
            width: 140
        },
        {
            label: '是否微小企业',
            prop: 'isMicroEnt',
            filterModel: '',
            filterType: 'select',
            type: 'select',
            optionsKey: 'SYS_YES_NO',
            width: 120
        },
        {
            label: '天眼参考行业',
            prop: 'tycIndustry',
            // filterModel: '',
            // filterType: 'input',
            width: 120
        },
        {
            label: '纳税登记人',
            prop: 'ebcuTaxpayers',
            filterModel: '',
            filterType: 'input',
            width: 140
        },
        {
            label: '纳税人类型',
            prop: 'ebcuTaxpayersType',
            filterModel: '',
            filterType: 'select',
            type: 'select',
            optionsKey: 'SYS_TAXER_TYPE',
            width: 120
        },
        {
            label: '注册金额',
            prop: 'ebcuRegisteredCapital',
            // filterModel: '',
            // filterType: 'numberRange',
            width: 150
        },
        {
            label: '经营范围',
            prop: 'businessScope',
            filterModel: '',
            filterType: 'input',
            width: 140
        },
        {
            label: '企业性质',
            prop: 'ebcuPlatformNature',
            filterModel: '',
            filterType: 'select',
            type: 'select',
            optionsKey: 'SYS_SUPPLIER_NATURE',
            width: 100
        },
        {
            label: '国家',
            prop: 'ebcuEbplCountryName',
            // filterModel: '',
            // filterType: 'select',
            width: 100
        },
        {
            label: '省',
            prop: 'ebcuEbplProvinceName',
            // filterModel: '',
            // filterType: 'select',
            width: 100
        },
        {
            label: '市',
            prop: 'ebcuEbplCityName',
            // filterModel: '',
            // filterType: 'select',
            width: 100
        },
        {
            label: '县区',
            prop: 'ebcuDistrictsName',
            // filterModel: '',
            // filterType: 'select',
            width: 100
        },
        {
            label: '乡镇/街道',
            prop: 'ebcuTownsName',
            // filterModel: '',
            // filterType: 'input',
            width: 150
        },
        {
            label: '地址',
            prop: 'ebcuAddress',
            filterModel: '',
            filterType: 'input',
            width: 150
        },
        {
            label: '智汇签验真',
            prop: 'isCertification',
            // filterModel: '',
            // filterType: 'select',
            type: 'select',
            optionsKey: 'SYS_IS_CERTIFICATION',
            width: 110
        },
        {
            label: '是否关联交易',
            prop: 'isRelatedTransaction',
            filterModel: '',
            filterType: 'select',
            type: 'select',
            optionsKey: 'SYS_YES_NO',
            width: 110
        },
        {
            label: '内部OU组织',
            prop: 'ouOrganizationName',
            // filterModel: '',
            // filterType: 'select',
            width: 150
        },
        {
            label: '是否POS机收款',
            prop: 'receiveByPos',
            // filterModel: '',
            // filterType: 'select',
            type: 'select',
            optionsKey: 'SYS_YES_NO',
            width: 120
        },
        {
            label: '销售产品',
            prop: 'mainProducts',
            filterModel: '',
            filterType: 'input',
            width: 130
        },
        {
            label: '公司简介',
            prop: 'companyProfile',
            filterModel: '',
            filterType: 'input',
            width: 130
        },
        {
            label: 'AI简介（试行）',
            prop: 'introduction',
            filterModel: '',
            filterType: 'input',
            width: 150
        },
        {
            label: '企业文化',
            prop: 'corporateCulture',
            filterModel: '',
            filterType: 'input',
            width: 150
        },
        {
            label: '公司网址',
            prop: 'companyUrl',
            filterModel: '',
            filterType: 'input',
            width: 110
        },
        {
            label: '电话',
            prop: 'ebcuTel',
            filterModel: '',
            filterType: 'input',
            width: 170
        },
        {
            label: '传真',
            prop: 'ebcuFax',
            filterModel: '',
            filterType: 'input',
            width: 170
        },
        {
            label: '电子邮箱',
            prop: 'ebcuEmail',
            filterModel: '',
            filterType: 'input',
            width: 100
        },
        {
            label: '邮编',
            prop: 'ebcuZipCode',
            filterModel: '',
            filterType: 'input',
            width: 100
        },
        {
            label: '备注',
            prop: 'ebcuRemark',
            // filterModel: '',
            // filterType: 'input',
            width: 100
        },
        {
            label: '审批状态',
            prop: 'approvalStatus',
            filterModel: '',
            filterType: 'select',
            type: 'select',
            optionsKey: 'SYS_CUST_APPROVAL_STATUS',
            width: 140
        },
        {
            label: '来源系统',
            prop: 'sysSource',
            // filterModel: '',
            // filterType: 'select',
            width: 100
        },
        {
            label: '内外部客户',
            prop: 'isGroupCustomer',
            // filterModel: '',
            // filterType: 'select',
            type: 'select',
            optionsKey: 'SYS_WM_IN_OR_OUT_CUSTOMER',
            width: 100
        },
        {
            label: '是否销售公司',
            prop: 'isSaleCompany',
            // filterModel: '',
            // filterType: 'select',
            type: 'select',
            optionsKey: 'SYS_YES_NO',
            width: 120
        },
        {
            label: '是否代理商',
            prop: 'isAgent',
            // filterModel: '',
            // filterType: 'select',
            type: 'select',
            optionsKey: 'SYS_YES_NO',
            width: 100
        },
        {
            label: '是否分销商',
            prop: 'isDistributor',
            // filterModel: '',
            // filterType: 'select',
            type: 'select',
            optionsKey: 'SYS_YES_NO',
            width: 100
        },
        {
            label: '客户销售易id',
            prop: 'crmCustomerId',
            // filterModel: '',
            // filterType: 'input',
            width: 150
        },
        {
            label: '开发人美信号',
            prop: 'customerOwnerCode',
            filterModel: '',
            filterType: 'input',
            width: 120
        },
        {
            label: '开发人名称',
            prop: 'customerOwnerName',
            filterModel: '',
            filterType: 'input',
            width: 100
        },
        // {
        //     label: '白名单审批编码',
        //     prop: 'customerWhitelistCode',
        //     type: 'slot',
        //     placeholder: '白名单审批编码',
        //     width: 160
        // },
        {
            label: '创建时间',
            prop: 'createTime',
            // filterModel: '',
            // filterType: 'timeRange',
            width: 150
        },
        {
            label: '创建用户',
            prop: 'createUserCode',
            // filterModel: '',
            // filterType: 'input',
            width: 150
        },
        {
            label: '创建用户名称',
            prop: 'createUserName',
            // filterModel: '',
            // filterType: 'input',
            width: 140
        },
        {
            label: '更新时间',
            prop: 'updateTime',
            // filterModel: '',
            // filterType: 'timeRange',
            width: 120
        },
        {
            label: '修改用户',
            prop: 'updateUserCode',
            // filterModel: '',
            // filterType: 'input',
            width: 120
        },
        {
            label: '修改用户名称',
            prop: 'updateUserName',
            // filterModel: '',
            // filterType: 'input',
            width: 120
        },
        {
            label: '是否成功同步集团',
            prop: 'pushStatusNonDynamic',
            type: 'select',
            optionsKey: 'CUSTOMER_PUSH_STATUS',
            width: 120
        },
        {
            label: '注册地址',
            prop: 'tycAddress',
            width: 150
        }
    ],
    matchOperator: {
        customerCode: 'CONTAINS',
        customerName: 'CONTAINS',
        customerShortName: 'CONTAINS',
        belongCustomerCode: 'CONTAINS',
        customerGroupName: 'CONTAINS',
        originalGroupCode: 'CONTAINS',
        supplierCode: 'CONTAINS',
        customerOwnerName: 'CONTAINS',
        societyCreditCode: 'CONTAINS',
        ebcuBusinessNo: 'CONTAINS',
        ebcuOrgBarcode: 'CONTAINS',
        ebcuTaxRegistNo: 'CONTAINS',
        ebcuLegalEntity: 'CONTAINS',
        ebcuNameEn: 'CONTAINS',
        idNumber: 'CONTAINS',
        sinosureCode: 'CONTAINS',
        tycIndustry: 'CONTAINS',
        ebcuTaxpayers: 'CONTAINS',
        businessScope: 'CONTAINS',
        ebcuTownsName: 'CONTAINS',
        ebcuAddress: 'CONTAINS',
        tycAddress: 'CONTAINS',
        mainProducts: 'CONTAINS',
        companyProfile: 'CONTAINS',
        introduction: 'CONTAINS',
        corporateCulture: 'CONTAINS',
        companyUrl: 'CONTAINS',
        ebcuTel: 'CONTAINS',
        ebcuFax: 'CONTAINS',
        ebcuEmail: 'CONTAINS',
        ebcuZipCode: 'CONTAINS',
        ebcuRemark: 'CONTAINS',
        crmCustomerId: 'CONTAINS',
        customerOwnerCode: 'CONTAINS',
        createUserCode: 'IN',
        createUserName: 'IN',
        updateUserCode: 'CONTAINS',
        updateUserName: 'CONTAINS',
        customerBodyType: 'IN',
        customerStatus: 'IN',
        customerChannel: 'IN',
        customerChannelRole: 'IN',
        industryCategoriesName: 'IN',
        industryType: 'IN',
        calCustomerLevelCode: 'IN',
        ebcuBuCode: 'IN',
        riskLevel: 'IN',
        ebcuCustomerType: 'IN',
        bizRevId: 'IN',
        customerProperty: 'IN',
        isVirtualCustomer: 'IN',
        teamType: 'IN',
        isImpExpCustomer: 'IN',
        regStatus: 'IN',
        isMicroEnt: 'IN',
        ebcuTaxpayersType: 'IN',
        ebcuPlatformNature: 'IN',
        ebcuEbplCountryCode: 'IN',
        ebcuEbplProvinceCode: 'IN',
        ebcuEbplCityCode: 'IN',
        ebcuDistricts: 'IN',
        isCertification: 'IN',
        isRelatedTransaction: 'IN',
        ouOrganization: 'IN',
        receiveByPos: 'IN',
        approvalStatus: 'IN',
        sysSource: 'IN',
        isGroupCustomer: 'IN',
        isSaleCompany: 'IN',
        isAgent: 'IN',
        isDistributor: 'IN',
        isWhitelist: 'IN',
        customerCategory: 'CONTAINS',
        customerCategoryCode: 'CONTAINS'
    },
    actions: { // 表格操作列的配置
        fixedWidth: 80, // fixedWidth（可选） 设置操作列的固定宽度，不加该参数默认是按钮list长度*50px
        list: [
            {
                label: '编辑',
                event: 'edit',
                displayRule: (row) => {
                    return true;
                }
            }
        ]
    }
};
// 校验白名单发起审批条件 data(arary) : 当前选择的数据   val : 审批类型
// eslint-disable-next-line max-lines-per-function
export const verifyWhiteCustomerFunc = (data, val) => { // 白名单配置审批发起
    const selectedRows = data;
    const isEnable = val === 'ON'; // 1为启用审批，2为停用审批
    // 收集不符合条件的客户编码
    const invalidStatusCodes = []; // 状态不等于有效的客户
    const virtualCustomerCodes = []; // 虚拟客户
    const whitelistErrorCodes = []; // 白名单相关错误

    // 遍历选中的客户进行校验
    selectedRows.forEach(row => {
        const customerCode = row.customerCode;
        const customerStatus = row.customerStatus;
        const isVirtualCustomer = row.isVirtualCustomer;
        const isWhitelist = row.isWhitelist; // 白名单字段，如果字段名不对需要调整

        // 校验客户状态：必须为有效（有效值为'1'）
        if (customerStatus !== '1' && customerStatus !== 1) {
            invalidStatusCodes.push(customerCode);
        }

        // 校验是否虚拟客户：必须不等于"是" Y
        if (isVirtualCustomer?.toString() === 'Y') {
            virtualCustomerCodes.push(customerCode);
        }
        // 根据启用/停用审批进行不同的白名单校验
        if (isEnable) {
            // 启用审批：是否白名单 不等于 是
            if (isWhitelist?.toString() === '1') {
                whitelistErrorCodes.push(customerCode);
            }
        } else {
            // 停用审批：是否白名单 等于 是
            if (isWhitelist?.toString() !== '1') {
                whitelistErrorCodes.push(customerCode);
            }
        }
    });
    const errorTextList = [];
    // 报错提示
    if (invalidStatusCodes.length > 0) {
        errorTextList.push(`仅支持有效的主客户发起白名单配置，以下客户不是有效客户：${invalidStatusCodes.join('，')}`);
    }

    if (virtualCustomerCodes.length > 0) {
        errorTextList.push(`仅支持有效的主客户发起白名单配置，以下客户不是主客户：${virtualCustomerCodes.join('，')}`);
    }

    if (whitelistErrorCodes.length > 0) {
        if (isEnable) {
            errorTextList.push(`以下客户已是白名单客户，无需再次发起，客户：${whitelistErrorCodes.join('，')}`);
        } else {
            errorTextList.push(`以下客户不是白名单客户，无需发起停用审批，客户：${whitelistErrorCodes.join('，')}`);
        }
    }
    if (errorTextList.length) {
        return errorTextList.join('<br />');
    }
    return false;
};
